import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { ReceiptService } from '../../../../services/receipt.service';
import { ToastrService } from 'ngx-toastr';
import { DataTransferService } from '../../../../services/DataTransferService';


@Component({
  selector: 'receipt-additional-charges',
  templateUrl: './additional-charges.component.html',
  styleUrls: ['./additional-charges.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({ 
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class AdditionalChargesComponent implements OnInit {

  additionalCharges: any[];
  chargeTypes: any[] = [];
  @Output() additionalChargesObj = new EventEmitter();
  @Output() editRequest = new EventEmitter();
  @Input() changing: boolean;
  @Input() resetAdditionalCharges: boolean;
  editable: boolean = true;
  isOpen: boolean = true;
  @Output() cancelAdditionalCharges = new EventEmitter();
  constructor(private receiptService: ReceiptService, private toaster: ToastrService, private data: DataTransferService) { }
  
  change() {
    this.isOpen = !this.isOpen;
    this.editable = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['resetAdditionalCharges'] != undefined) {
      var reset = changes['resetAdditionalCharges'].currentValue
      if (reset == true) {
        this.additionalCharges = [{ chargeType: -1, chargeValue: 0, chargeDescription: '', chargeTypeDescription: '' }];
        this.additionalChargesObj.emit(null);
        this.isOpen = true;
        this.editable = true;
      }
    }
  }

  ngOnInit() {
    this.receiptService.getAdditionalAmounts((res) => {
      var additionalAmounts = res as any[];
      this.chargeTypes.push({
        Id: -1,
        Description: 'Select'
      });
      this.chargeTypes = this.chargeTypes.concat(additionalAmounts);
    }, (err) => { })

    this.additionalCharges = [{ chargeType: -1, chargeValue: 0, chargeDescription: '', chargeTypeDescription: ''  }];
  }
  getSelectedChargeTypeText(item) {
    return this.chargeTypes.filter(x => x.Id == item)[0].Description
  }
  isLastIndex(index) {
    return index == this.additionalCharges.length - 1;
  }
  addAddtionalCharge(item) {
    if (item.chargeType != -1 && (item.chargeValue != null && item.chargeValue != '') && (item.chargeDescription != null && item.chargeDescription != ''))
      this.additionalCharges.push({ chargeType: -1, chargeValue: 0, chargeDescription: '', chargeTypeDescription: ''});
  }
  getAddtionalCharges(item) {
    if (item.chargeType != -1 && (item.chargeValue != null && item.chargeValue != '') && (item.chargeDescription != null && item.chargeDescription != '')) {

      this.additionalCharges.forEach((x) => {
        x.chargeTypeDescription = this.getSelectedChargeTypeText(x.chargeType);
      });
      this.editable = false;
      this.additionalChargesObj.emit(this.additionalCharges)
      this.editRequest.emit(false)
      this.isOpen = !this.isOpen;
    }
  }
  validationMessage() {
  }
  removeAdditionalCharge(index) {
      if (this.additionalCharges.length > 1)
          this.additionalCharges.splice(index, 1);
      else {
          this.cancelAdditionalCharges.emit(true);
        this.additionalCharges = [{ chargeType: -1, chargeValue: 0, chargeDescription: '', chargeTypeDescription: '' }];
      }
  }
  editAdditionalCharges() {
    this.editRequest.emit(true);
      this.editable = true;
  }
}
